import { Editor, Element, Transforms } from 'slate';
import { isCurrentSelectionCollapsed } from '../../lib/queries';
import { AulaPlugin } from '../plugins';
import { HeadingFormats } from '../headings/headings';
import { blockQuoteType } from '../blockQuote/blockQuoteType';
import { toggleBlockType } from '../../lib/commands';

const types = [
  blockQuoteType,
  HeadingFormats.h1,
  HeadingFormats.h2,
  HeadingFormats.h3,
];

export const handleBackspace: AulaPlugin = (editableProps, editor) => ({
  ...editableProps,
  onKeyDown: (e) => {
    const { selection } = editor;
    if (editableProps.onKeyDown) editableProps.onKeyDown(e);
    if (e.key === 'Backspace' && selection != null) {
      const [node, path] = Editor.node(editor, selection, { depth: 1 });

      if (node == null) return;

      if (
        isCurrentSelectionCollapsed(editor) &&
        Element.isElement(node) &&
        Editor.isEnd(editor, selection.focus, path) &&
        node?.type != null &&
        types.includes(node.type)
      ) {
        const text = Editor.string(
          editor,
          Editor.range(editor, Editor.start(editor, path), selection.focus),
        );

        if (text === '' && editor.selection != null) {
          /**
           * If we're pressing backspace at the beginning of a block we want
           * to replace it with a default block instead
           */
          e.preventDefault();
          toggleBlockType(editor, undefined, editor.selection);
        } else if (text.endsWith('\n')) {
          e.preventDefault();

          /**
           * This turns the last soft line break into a paragrph
           * 1. Delete the last character
           * 2. Insert node
           */
          Editor.deleteBackward(editor);
          Transforms.insertNodes(
            editor,
            [
              {
                children: [
                  {
                    text: '',
                  },
                ],
              },
            ],
            {
              at: [path[0] + 1],
              select: true,
            },
          );
        }
      }
    }
  },
});
